import React, { useState } from 'react';
import classNames from 'classnames';

import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Layout, Drawer, Dropdown, Avatar } from 'antd';
import { CaretDownOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { Button, ButtonType } from '@bettercomp/ui-components';
import { checkUserPermissions } from 'hooks/useHasPermissions';
import { PATH } from 'common/constants';
import { NavMenu } from 'components/NavMenu';
import { logout } from 'service/cognitoService';
import { selectUser } from 'redux/user/selectors';
import { PermissionCode } from 'types';

import { Notifications } from './Notifications';
import { SuperUserBar } from '../SuperUserBar';
import MobileMenuIcon from './menu.svg';
import cn from './styles.module.scss';

export const Header = React.memo(() => {
  const user = useSelector(selectUser);
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const canManageFiles = user ? checkUserPermissions(user, [PermissionCode.LOAD_FILES]) : false;
  const canManageDataLoaders = user ? checkUserPermissions(user, [PermissionCode.MANAGE_DATA_LOADER]) : false;

  const router = useRouter();

  const backHome = () => {
    router.push('/');
  };

  const handleSignOut = async () => {
    logout();
  };

  const showMobileMenu = () => {
    setOpenMobileMenu(true);
  };

  const onClose = () => {
    setOpenMobileMenu(false);
  };

  const handleCloudClick = () => {
    if (canManageFiles) {
      router.push(PATH.FILES_UPLOAD);
    }
    if (canManageDataLoaders) {
      router.push(PATH.DATA_LOADERS);
    }
  };

  return (
    <Layout.Header className={classNames(cn.headerContainer, cn.header)}>
      <div className={cn.content}>
        <div className={cn.logoContainer}>
          <div className={cn.logo}>
            <img width={160} height={24} src='/assets/images/logo/bc-without-slogan.png' onClick={backHome} />
          </div>
          <SuperUserBar className={cn.suHeader} />
        </div>
        {user && (
          <>
            <NavMenu className={cn.menu} />
            <div className={cn.userMenu}>
              {(canManageFiles || canManageDataLoaders) && (
                <Button
                  type={ButtonType.Icon}
                  icon={<CloudUploadOutlined className={cn.uploadIcon}/>}
                  onClick={handleCloudClick}
                />
              )}
              <div className={cn.notificationContainer}>
                <Notifications />
              </div>
              <Dropdown
                placement="bottomRight"
                forceRender
                menu={{
                  items: [
                    {
                      key: 'signOut',
                      label: (
                        <div onClick={handleSignOut} data-testid="signOutButton">
                          SIGN OUT
                        </div>
                      ),
                    },
                  ],
                }}
              >
                <div className={cn.user}>
                  <Avatar
                    className={cn.avatar}
                  >
                    {user && user.firstName && user.firstName.charAt(0).toUpperCase()}
                  </Avatar>
                  <CaretDownOutlined />
                </div>
              </Dropdown>
              <MobileMenuIcon className={cn.menuMb} onClick={showMobileMenu}/>
              <Drawer
                rootClassName={cn.drawer}
                placement="right"
                closable={false}
                onClose={onClose}
                open={openMobileMenu}
              >
                <NavMenu
                  mode="vertical"
                  onClick={onClose}
                />
              </Drawer>
            </div>
          </>
        )}
      </div>
    </Layout.Header>
  );
});

Header.displayName = 'Header';
